
namespace GeniuzPOS.Purchase {

    @Serenity.Decorators.registerClass()
    export class ReportDailyPIDialog extends Serenity.EntityDialog<ReportDailyPIRow, any> {
        protected getFormKey() { return ReportDailyPIForm.formKey; }
        protected getIdProperty() { return ReportDailyPIRow.idProperty; }
        protected getLocalTextPrefix() { return ReportDailyPIRow.localTextPrefix; }
        protected getNameProperty() { return ReportDailyPIRow.nameProperty; }
        protected getService() { return ReportDailyPIService.baseUrl; }
        protected getDeletePermission() { return ReportDailyPIRow.deletePermission; }
        protected getInsertPermission() { return ReportDailyPIRow.insertPermission; }
        protected getUpdatePermission() { return ReportDailyPIRow.updatePermission; }

        protected form = new ReportDailyPIForm(this.idPrefix);

    }
}